import { useEffect, useState } from "react";
import { KXYear } from "../Models/KXYear";
import { ConstantImport } from "../Constants/ConstantImport";
import { NewTabLink } from "./UI/NewTabLink";

export type KXOffersProps = {
    KXAcademicYear: KXYear;
    KXError: string;
    StatusFlag: string;
    StatusDescription: string;
    KxStudentGuid: string;
}

export function KXOffers(props: KXOffersProps) {
    const [lblKxOffersTitle, setlblKxOffersTitle] = useState("");
    const [lblAdditionalInfo, setlblAdditionalInfo] = useState("");
    const [lblKxOffer, setlblKxOffer] = useState("");
    const [linkButtonOffersKx, setlinkButtonOffersKx] = useState("");
    const [lblKxInduction, setlblKxInduction] = useState("");
    const [linkButtonInductions, setlinkButtonInductions] = useState("");

    useEffect(() => {
        setlblKxOffersTitle("Accommodation offers for " + props.KXAcademicYear.KXFormat + " academic year:");
        switch (props.StatusFlag) {
            case "OFFER":
                setlblKxOffer(props.StatusDescription + ". ");
                setlinkButtonOffersKx("View (and accept or reject) your accommodation offer(s).");
                break;
            case "ACCEPT":
                setlblKxInduction(props.StatusDescription + ". ");
                setlinkButtonInductions("View accepted accommodation offer(s) and/or complete your eInduction to accommodation at Essex.");
                break;
            default:
                //if not in ACCEPT or OFFER state:
                setlblAdditionalInfo("No offers.");
                break;
        }
    }, [props]);

    return <>
        {props.KXError !== "" && <p>{props.KXError}</p>}
        {lblKxOffersTitle !== "" && <p>{lblKxOffersTitle}</p>}
        <p>&nbsp;</p>
        {(lblKxOffer !== "" && linkButtonOffersKx !== "") && <>
            <p><label htmlFor="linkButtonOffersKx">{lblKxOffer}</label></p>
            <p><NewTabLink id="linkButtonInductions" to={ConstantImport.KXLinkURL + props.KxStudentGuid}>{linkButtonOffersKx}</NewTabLink></p>
        </>}
        {(lblKxInduction !== "" && linkButtonInductions !== "") && <>
            <p><label htmlFor="linkButtonInductions">{lblKxInduction}</label></p>
            <p><NewTabLink id="linkButtonInductions" to={ConstantImport.KXLinkURL + props.KxStudentGuid}>{linkButtonInductions}</NewTabLink></p>
        </>}
        {lblAdditionalInfo !== "" && <p>{lblAdditionalInfo}</p>}
    </>;
}
